import React from "react";
import MobileSecViewsHeader from "../../components/MobileSecViewsHeader";
import NewUnitForm from "../../components/NewUnitForm";
import { useNavigate } from "react-router-dom";

const MobileNewUnit = () => {
  const navigate = useNavigate();

  return (
    <div className="w-100 h-100 border-box p-8 scroll">
      <div className="mb-4">
        <MobileSecViewsHeader title={"Nueva Unidad"} route={"/units"} />
      </div>
      <NewUnitForm
        setShowForm={() => {}}
        extraFunc={() => navigate("/units")}
        isMobile={true}
      />
    </div>
  );
};

export default MobileNewUnit;
